import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "mb-2" };
const _hoisted_2 = {
    key: 0,
    class: "flex flex-wrap gap-4 py-4"
};
const _hoisted_3 = ["aria-label"];
import { Button, ButtonGroup, NavHeader } from "@eudonet/opal";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { usePermissions } from "@/shared/composables/usePermissions";
import { activeTaxReceiptsTab, TAX_RECEIPTS_HEADER_TAB_KEYS, TAX_RECEIPTS_TAB_BY_KEY, TAX_RECEIPTS_TABS, } from "../../composables/taxReceiptsTabs";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TaxReceiptsPageHeader',
    props: {
        subtitle: {}
    },
    setup(__props) {
        const { t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const { can } = usePermissions();
        // Same gate as the route behind each tab: a reader never sees a tab the guard would refuse.
        const visibleTabs = computed(() => TAX_RECEIPTS_TABS.filter((tab) => TAX_RECEIPTS_HEADER_TAB_KEYS.includes(tab.key) && can(tab.requiresCapability)));
        const dashboardDelivered = TAX_RECEIPTS_HEADER_TAB_KEYS.includes("dashboard");
        const activeTab = computed(() => activeTaxReceiptsTab(route.path));
        const screenLabel = computed(() => {
            const tab = TAX_RECEIPTS_TABS.find((candidate) => candidate.key === activeTab.value);
            return tab ? t(tab.labelKey) : "";
        });
        // The area label leads back to the dashboard only once that screen is delivered: until then it
        // would lead into the empty placeholder.
        const backTarget = computed(() => dashboardDelivered && activeTab.value !== "dashboard"
            ? {
                label: t("finance.taxReceipts.title"),
                href: router.resolve({ name: TAX_RECEIPTS_TAB_BY_KEY.dashboard.routeName }).href,
            }
            : undefined);
        // "Paramètres · Reçus fiscaux": the screen first, the area second, like the prototype.
        const pageTitle = computed(() => screenLabel.value ? t("finance.taxReceipts.pageTitle", { screen: screenLabel.value }) : t("finance.taxReceipts.title"));
        function goToDashboard() {
            void router.push({ name: TAX_RECEIPTS_TAB_BY_KEY.dashboard.routeName });
        }
        // A plain push: the page being left owns its unsaved-changes guard (onBeforeRouteLeave), so a
        // refused navigation simply keeps the current tab active.
        function goTo(tab) {
            if (tab.key === activeTab.value)
                return;
            void router.push({ name: tab.routeName });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(NavHeader), {
                    type: "settings",
                    title: pageTitle.value,
                    description: __props.subtitle,
                    back: backTarget.value,
                    onBack: goToDashboard
                }, null, 8 /* PROPS */, ["title", "description", "back"]),
                (visibleTabs.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("nav", {
                            class: "self-center overflow-y-auto me-auto",
                            "aria-label": _ctx.$t('finance.taxReceipts.tabsLabel')
                        }, [
                            _createVNode(_unref(ButtonGroup), {
                                "overflow-label": _ctx.$t('common.tabs.next'),
                                "overflow-previous-label": _ctx.$t('common.tabs.previous')
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTabs.value, (tab) => {
                                        return (_openBlock(), _createBlock(_unref(Button), {
                                            key: tab.key,
                                            variant: "tertiary",
                                            label: _ctx.$t(tab.labelKey),
                                            active: tab.key === activeTab.value,
                                            "aria-current": tab.key === activeTab.value ? 'page' : undefined,
                                            "data-testid": `tax-receipts-tab-${tab.key}`,
                                            onClick: ($event) => (goTo(tab))
                                        }, null, 8 /* PROPS */, ["label", "active", "aria-current", "data-testid", "onClick"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["overflow-label", "overflow-previous-label"])
                        ], 8 /* PROPS */, _hoisted_3)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
